var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "account_svg__ds",
    x1: 132.31,
    y1: 138.83,
    x2: 297.97,
    y2: 138.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m380.35,360.95l.46-14.41v-.39c0-29.34-11.41-56.92-32.16-77.65-20.73-20.74-48.3-32.17-77.65-32.17h-111.75c-29.33,0-56.91,11.42-77.64,32.16-20.69,20.68-32.11,48.18-32.17,77.44l-.45,14.23c-.1,3.26,1.14,6.46,3.4,8.8,2.27,2.34,5.43,3.68,8.69,3.68h307.16c6.57,0,11.88-5.15,12.09-11.71Zm-306.76-12.48l.06-1.92v-.39c0-22.86,8.92-44.36,25.08-60.54,16.18-16.17,37.68-25.08,60.54-25.08h111.74c22.86,0,44.36,8.91,60.54,25.08,16.13,16.13,25.03,37.57,25.08,60.36l-.08,2.49H73.59Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.73,64.02c-11.16-5.32-23.14-8.02-35.6-8.02-22.13,0-42.93,8.62-58.56,24.26-15.65,15.64-24.26,36.44-24.26,58.57,0,22.13,8.61,42.93,24.26,58.57,15.63,15.65,36.43,24.26,58.57,24.26h.02c22.12,0,42.92-8.62,58.55-24.26,15.65-15.64,24.27-36.44,24.26-58.57,0-19.45-6.87-38.35-19.37-53.24-7.6-9.05-17.23-16.5-27.86-21.57Zm-35.59,133.44c-15.65,0-30.38-6.1-41.46-17.17-11.07-11.08-17.17-25.81-17.18-41.46,0-15.65,6.1-30.38,17.17-41.46,11.08-11.07,25.81-17.17,41.46-17.18,8.82,0,17.29,1.91,25.18,5.67,7.51,3.58,14.32,8.84,19.64,15.16l.1.13c8.84,10.53,13.7,23.91,13.71,37.68,0,15.65-6.1,30.38-17.17,41.46-11.08,11.07-25.81,17.17-41.46,17.18Z",
    style: {
      fill: "url(#account_svg__ds)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.0ae4a242cb8e523358e7244f68c4d69c.svg";
export { ForwardRef as ReactComponent };